import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { getLinariaClassName } from '../../../../utils/getLinariaClassName';
import { baseInputSizeStyles, baseInputTypographyStyles, getBaseInputIconPaddingStyles, InputBaseSize, StartIconsWrapper } from '../InputBase';
import { NoStyleButton } from '../NoStyleButton';
type Props = {
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether the input is disabled */
  disabled?: boolean;
  /** An Icon to display on the left side of the input */
  icon?: JSX.Element;
  /** ID of this component, passed down by the controlling parent component */
  id: string;
  /** Whether the input is rounded */
  isRounded?: boolean;
  /** An onClick callback passed down by the controlling parent component */
  onClick?: (event: React.SyntheticEvent<Element, Event>) => void;
  /** Content to be used as the input placeholder */
  placeholder?: ReactNode;
  /** The size of the input */
  size?: InputBaseSize;
  /** HTML class to be include in the button */
  className?: string;
  /** The content of the InputButton, a react component or pure text */
  children: ReactNode;
  /** Style prop is used by Linaria to pass CSS variables in cases when we need to style custom components in this way: `const StyledButton = styled(InputButton)` */
  style?: React.CSSProperties;
};
const _exp8 = /*#__PURE__*/() => ({
  sizeVariant,
  withStartIcon,
  isRounded
}) => getBaseInputIconPaddingStyles({
  sizeVariant,
  withStartIcon,
  isRounded
}).paddingLeft;
export const InputButtonStyledContainer = /*#__PURE__*/styled('div')({
  name: "InputButtonStyledContainer",
  class: "i1iq6hmr",
  propsAsIs: false,
  vars: {
    "i1iq6hmr-0": [_exp8()]
  }
});
const _exp10 = /*#__PURE__*/() => NoStyleButton;
const ButtonElement = /*#__PURE__*/styled(_exp10())({
  name: "ButtonElement",
  class: "b5ykw0k",
  propsAsIs: true
});
export const InputButton = ({
  dataId,
  disabled,
  icon,
  id,
  isRounded,
  onClick,
  placeholder,
  size = 'lg',
  className,
  children,
  style
}: Props) => <ButtonElement onClick={onClick} className={className} data-id={dataId} style={style} disabled={disabled}>
    <InputButtonStyledContainer id={id} sizeVariant={size} isRounded={isRounded} withStartIcon={Boolean(icon)} className={cx(`${getLinariaClassName(InputButtonStyledContainer)}--size-${size}`, `${baseInputSizeStyles}--size-${size}`, `${baseInputTypographyStyles}--size-${size}`, isRounded && 'isRounded', !children && 'hasPlaceholder')}>
      {children ? children : placeholder}
    </InputButtonStyledContainer>
    {icon && <StartIconsWrapper sizeVariant={size}>{icon}</StartIconsWrapper>}
  </ButtonElement>;

require("./InputButton.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./InputButton.tsx");